(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-amazon', {
            parent: 'entity',
            url: '/campagna-amazon?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaAmazon.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazons.html',
                    controller: 'CampagnaAmazonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaAmazon');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-amazon-detail', {
            parent: 'campagna-amazon',
            url: '/campagna-amazon/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnaAmazon.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-detail.html',
                    controller: 'CampagnaAmazonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnaAmazon');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CampagnaAmazon', function($stateParams, CampagnaAmazon) {
                    return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-amazon',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-amazon-detail.edit', {
            parent: 'campagna-amazon-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-amazon.new', {
            parent: 'campagna-amazon',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                datains: null,
                                csv: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('campagna-amazon');
                });
            }]
        })
        .state('campagna-amazon.edit', {
            parent: 'campagna-amazon',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-dialog.html',
                    controller: 'CampagnaAmazonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-amazon.delete', {
            parent: 'campagna-amazon',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-amazon/campagna-amazon-delete-dialog.html',
                    controller: 'CampagnaAmazonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CampagnaAmazon', function(CampagnaAmazon) {
                            return CampagnaAmazon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-amazon', null, { reload: 'campagna-amazon' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
